import { useEffect } from 'react'

import { useParams } from 'react-router-dom'

import { useSidebarVisibility } from 'src/Hooks/useSidebarVisibility'
import { useCheckoutTimerFeatureFlag } from 'src/Hooks/useCheckoutTimerFeratureFlag'
import { updateCountdown } from 'src/Redux/checkoutCountdown-process'
import { useAppDispatch } from 'src/Hooks/redux'
import { useBonusTooltipTimer } from 'src/Hooks/useBonusTooltip'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'

import { useCheckTikTokCampaignStatus } from './useCheckTikTokCampaignStatus'
import { useDefaultTikTokCampaignStartDate } from './useDefaultTikTokCampaignStartDate'
import { useBackFromPaymentPageTikTok } from './useBackFromPaymentPageTikTok'
import { useScheduleStartEvent } from './useScheduleStartEvent'

export const useScheduleTikTokCampaign = (): void => {
  const dispatch = useAppDispatch()
  const { number } = useParams()

  useSidebarVisibility()
  useCheckTikTokCampaignStatus()
  useDefaultTikTokCampaignStartDate()
  useBackFromPaymentPageTikTok()
  useScheduleStartEvent()

  useBonusTooltipTimer({
    platform: CampaignPlatformTypeEnum.TIKTOK,
  })
  useCheckoutTimerFeatureFlag({
    platform: CampaignPlatformTypeEnum.TIKTOK,
    campaignId: Number(number),
  })

  useEffect(
    () => () => {
      dispatch(updateCountdown(null))
    },
    [dispatch],
  )
}
